// extracted by mini-css-extract-plugin
export default {"pageWrap":"Kc-z","fullWidth":"Lc-z","heading":"Mc-z","fullBleed":"Nc-z","hidden":"Oc-z"};